import { render, staticRenderFns } from "./PasswordCard.vue?vue&type=template&id=51f4a05a&"
import script from "./PasswordCard.vue?vue&type=script&lang=js&"
export * from "./PasswordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports